import DOMPurify from 'dompurify'

const sanitizedContentData = (contendClen) => ({
  __html: DOMPurify.sanitize(contendClen),
})

export default sanitizedContentData
